import { compose } from "lodash/fp";

import ContactSellersAgentCTABase from "./components/ContactSellersAgentCTA";
import ListingAgentContactDrawerBase from "./components/ListingAgentContactDrawer";
import store from "./redux/store";
import withInitialization from "./redux/utilities/withInitialization";
import withReduxProvider from "./redux/utilities/withReduxProvider";

const enhance = compose(
  withInitialization(store),
  withReduxProvider(store)
);

const ListingAgentContactDrawer = enhance(ListingAgentContactDrawerBase);

const ContactSellersAgentCTA = withReduxProvider(store)(
  ContactSellersAgentCTABase
);

export { ListingAgentContactDrawer, ContactSellersAgentCTA };
